import React from 'react';
import styles from './PaginationButtons.module.scss';
import Icon from '../Icon/Icon';

export interface PaginationButtonsProps {
  onClick: (direction: 'previous' | 'next') => void;
  disabledPrevious?: boolean;
  disabledNext?: boolean;
}

const PaginationButtons: React.FC<PaginationButtonsProps> = ({ onClick, disabledNext, disabledPrevious }) => {
  return (
    <div className={styles.root}>
      <button
        type="button"
        className={styles.button}
        onClick={() => onClick('previous')}
        disabled={disabledPrevious}
        aria-label="Previous Page">
        <Icon width={20} height={20} name="arrowRight" />
      </button>
      <button
        type="button"
        aria-label="Next Page"
        className={styles.button}
        onClick={() => onClick('next')}
        disabled={disabledNext}>
        <Icon width={20} height={20} name="arrowRight" />
      </button>
    </div>
  );
};

export default PaginationButtons;
